
import { SETARTICLEVARIANTORDERING_TYPES } from '../actions/setArticleVariantOrdering'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(SETARTICLEVARIANTORDERING_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer